import request from '@/utils/request'

/**
 * 发起支付
 * @param {*} data
 * @returns
 */
export function sendPay(data) {
  return request({
    url: '/mg/daohang-pay-api/sendPay',
    method: 'put',
    data,
    loading: true,
  })
}

// 支付类型查询
export function getPaymentType(data) {
  return request({
    url: '/mg/daohang-order-api/paymentType/list',
    method: 'post',
    data,
  })
}


//支付类型查询 page
export function paymentMethodPage(data) {
  return request({
    url: '/mg/daohang-order-api/paymentType/page',
    method: 'post',
    data,
  })
}


export function paymentMethodBatchSave(data) {
  return request({
    url: '/mg/daohang-order-api/paymentType/batchSave',
    method: 'put',
    data,
  })
}

